import {Form} from "../form/form";

export class SearchForm extends Form{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        super.ready();
        this.$root.on(
            "formField:changeVal",
            (ev,data)=>{
                if(data && data.sourceEvent && $(data.sourceEvent.target).attr("name")=="q"){
                    return;
                }
                //prevent sending of nested fields
                this.$root.find(".js-form:input").prop("disabled",true);
                this.$root.submit();
            }
        );

        this.$root.find(".js-form-field-input").after($("<input type='submit' />").hide());

        SearchForm.addMobileSearchButtons(this.$root,()=>this.$root.submit());
    }

    /**
     * Adds a magnifier button (mobile only) at the end of each free text input inside $container
     * @param {jQuery} $container
     * @param {function} callback called with the input jQuery element when the button is clicked
     */
    static addMobileSearchButtons($container,callback){
        $container.find(".js-form-field-input input[type=text][name]").each(
            (index,input)=>{
                const $input = $(input);
                const $button = $("<button type='button' class='cp-search-form__mobile-search-button hidden-md-up'><i class='mdi mdi-magnify'></i></button>");
                $input.wrap($("<div class='cp-search-form__mobile-search-wrapper' />")).after($button);
                //keeps focus on the input so its change event is not fired before the click
                $button.on("mousedown",(ev)=>ev.preventDefault());
                $button.click(
                    (ev)=>{
                        ev.preventDefault();
                        callback($input);
                    }
                );
            }
        );
    }
}
